import Grid from "@mui/material/Grid";
import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import {
  CmpTypographyField,
  CmpInputField,
  CmpSelectField,
  CmpRadioButton,
  CmpCheckboxFieldIndeterminate,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox.js";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import GCBrandSearch from "../../../Component/Common/ReuseableComponent/GCBrandSearch.jsx";
import GCSupplierSearch from "../../../Component/Common/ReuseableComponent/GCSupplierSearch.jsx";

export default function WmsHead({
  fLocation_MultiSelect,
  sLocationData,

  fMainGroup_MultiSelect,
  sMainGroupData,
  fSubGroup_MultiSelect,
  sSubGroupData,

  fCategory_MultiSelect,
  sCategoryData,

  fBrand_MultiSelect,
  sBrandData,

  fBrandCategory_MultiSelect,
  sBrandCategoryData,

  fMainSupplier_MultiSelect,
  sMainSupplierData,

  //multiselect
  sWebStockReportData,
  sWebStockReportArr,

  HeadObject,
  setHeadObject,
  fLocation,
  fMainGroup,
  fSubGroup,
  fCategory,
  fMainSupplier,
  fBrand,
  fReportType,
  fDCItems,
  fListedCheckBox,
  fStock,
  fConsumption,
  fProjection,
  //item name
  fItem,
  fItemName_onKeyUp,
  fItemName,
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
}) {
  return (
    <form id="DcItemsStatusReportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center"
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"DC Items Status Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName={"sLocation"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"02"}
                options={sLocationData}
                xDisabled={
                  HeadObject?.sLocation?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Main Group"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"03"}
                xLabelText="sMainGroup"
                xValue={HeadObject.sMainGroup}
                xOnChange={fMainGroup}
                xName={"sMainGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"04"}
                options={sMainGroupData}
                xDisabled={
                  HeadObject?.sMainGroup?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sMainGroupArr}
                setValue={fMainGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Sub Group"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"05"}
                xLabelText="sSubGroup"
                xValue={HeadObject.sSubGroup}
                xOnChange={fSubGroup}
                xName={"sSubGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"06"}
                options={sSubGroupData}
                xDisabled={
                  HeadObject?.sSubGroup?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sSubGroupArr}
                setValue={fSubGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Group"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"07"}
                xLabelText="sCategory"
                xValue={HeadObject.sCategory}
                xOnChange={fCategory}
                xName={"sCategory"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"08"}
                options={sCategoryData}
                xDisabled={
                  HeadObject?.sCategory?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sCategoryArr}
                setValue={fCategory_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Brand"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"11"}
                xLabelText="sBrand"
                xValue={HeadObject.sBrand}
                xOnChange={fBrand}
                xName={"sBrand"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            {/* <Grid item xs={6} sm={6} md={4} lg={4}>
              <GCAutocompleteCheckbox
                xtabIndex={"12"}
                options={sBrandData}
                xDisabled={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sBrandArr}
                setValue={fBrand_MultiSelect}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <GCAutocompleteCheckbox
                xtabIndex={"13"}
                options={sBrandCategoryData}
                xDisabled={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sBrandCategoryArr}
                setValue={fBrandCategory_MultiSelect}
              />
            </Grid> */}
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCBrandSearch
                xValue={HeadObject?.sBrandSearchValue} //main input value
                xOnChange={(e) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sBrandSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                basketValue={HeadObject?.sBrandArr} //Search basket array
                xListValue={HeadObject?.sBrandArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sBrandArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Supplier"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sMainSupplier"
                xValue={HeadObject.sMainSupplier}
                xOnChange={fMainSupplier}
                xName={"sMainSupplier"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              {/* <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sMainSupplierData}
                xDisabled={
                  HeadObject?.sMainSupplier?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                xValue={HeadObject.sMainSupplierArr}
                setValue={fMainSupplier_MultiSelect}
              /> */}
              <GCSupplierSearch
                xValue={HeadObject.sSupplierSearchValue} //main input value
                xOnChange={(e) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sSupplierSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  HeadObject?.sMainSupplier?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                basketValue={HeadObject?.sMainSupplierArr} //Search basket array
                xListValue={HeadObject?.sMainSupplierArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sMainSupplierArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Item"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"14"}
                xLabelText="sItem"
                xValue={HeadObject.sItem}
                xOnChange={fItem}
                xName={"sItem"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <CmpInputField
                xValue={HeadObject.sItemCode}
                xType={"text"} // text/number/password
                xName={"sItemCode"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5}>
              <GCToggleSearch
                xtabIndex={"15"}
                xName={"sItemName"}
                xType={"text"}
                xValue={HeadObject?.sItemName}
                xReadOnly={
                  HeadObject?.sItem?.toUpperCase() === "ALL" ? true : false
                }
                xOnChange={fItemName}
                xOnKeyUp={fItemName_onKeyUp}
                xError={false}
                xErrorMessage={""}
                xMediaQuery={xMediaQuery}
                xonClickbtn={xonClickbtn}
                xrows={xrows}
                xcolumns={xcolumns} //head
                xRowCellClick={xRowCellClick}
                xRowClick={xRowClick}
                xToggle={xToggle}
                xData={xData}
                xOnChangeDropdownInput={xOnChangeDropdownInput}
                xDropdownObj={xDropdownObj}
                xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Report Type"} />
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <CmpRadioButton
                value="DC_ITEMS"
                label="DC - Items"
                checked={HeadObject.sReportType === "DC_ITEMS"}
                onChange={fReportType}
              />
            </Grid>
            <Grid
              item
              xs={3}
              sm={3}
              className={
                HeadObject.sReportType === "DC_ITEMS"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpCheckboxFieldIndeterminate
                xChecked={HeadObject.sDCItems === "P"}
                xCheckedIndeterminate={HeadObject.sDCItems === "B"}
                xOnChange={fDCItems}
                xDisabled={false}
                xName={"sDCItems"}
                xNameField={
                  HeadObject.sDCItems === "P"
                    ? "DC Discontinued"
                    : HeadObject.sDCItems === "B"
                    ? "Both"
                    : "Discontinued"
                }
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}></Grid>

            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpRadioButton
                value="LISTED"
                label="Listed"
                checked={HeadObject.sReportType === "LISTED"}
                onChange={fReportType}
              />
            </Grid>
            <Grid
              item
              xs={3}
              sm={3}
              md={1.5}
              lg={1.5}
              className={
                HeadObject.sReportType === "LISTED"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpCheckboxFieldIndeterminate
                xChecked={HeadObject.sListedCheckBox === "Y"}
                xCheckedIndeterminate={HeadObject.sListedCheckBox === "B"}
                xOnChange={fListedCheckBox}
                xDisabled={false}
                xName={"sListedCheckBox"}
                xNameField={
                  HeadObject.sListedCheckBox === "Y"
                    ? "Listed"
                    : HeadObject.sListedCheckBox === "B"
                    ? "Both"
                    : "Non-Listed"
                }
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Include"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpCheckboxField
                xChecked={HeadObject.sStock === "Y"}
                xOnChange={fStock}
                xDisabled={false}
                xName={"sStock"}
                xNameField={"Stock"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpCheckboxField
                xChecked={HeadObject.sConsumption === "Y"}
                xOnChange={fConsumption}
                xDisabled={false}
                xName={"sConsumption"}
                xNameField={"Consumption"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpCheckboxField
                xChecked={HeadObject.sProjection === "Y"}
                xOnChange={fProjection}
                xDisabled={false}
                xName={"sProjection"}
                xNameField={"Projection"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
